import { render } from "./Spinner.vue?vue&type=template&id=c993a59e&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=c993a59e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c993a59e"]])

export default __exports__